import { serialize } from '@/@core/libs/serialize/util'
import Http from '@/services/http'

// LIST ALL Target Gender
export const genderList = (params = '') => Http.get(`/marketing-gender-dominances${serialize(params)}`)
export const genderCreate = (params = '') => Http.post('/marketing-gender-dominances', params)
export const genderByID = (params = '') => Http.get(`/marketing-gender-dominances/${params}`)
export const genderUpdate = (params = '') => Http.put(`/marketing-gender-dominances/${params.id}`, params)
export const genderDestroy = (params = '') => Http.delete(`/marketing-gender-dominances/${params.id}`)
